/*!
 * Select de usuarios de empresa por empresa
 */

;(function ($, window, document, undefined) {

  // Create the defaults once
  var pluginName = 'beCompanyManagement',
    defaults = {
      propertyName: "value"
    };

  // The actual plugin constructor
  function Plugin(element, options) {
    this.element = element;
    this.$element = $(element);

    this.options = $.extend({}, defaults, options);

    this._defaults = defaults;
    this._name = pluginName;

    this.init();
  }

  Plugin.prototype.init = function () {
    var Plugin = this;
    Plugin.$element.find('#js-beCompanyManagement--link-button').on('click', function () {
      $.post({
        url: '/empresas/link',
        data: {companyId: $(this).data('company_id')},
        success: function (data) {
          location.reload();
        }
      });
    })

    Plugin.$element.find('#js-beCompanyManagement--unlink-button').on('click', function () {
      $.post({
        url: '/empresas/unlink',
        data: {companyId: $(this).data('company_id')},
        success: function (data) {
          location.reload();
        }
      });
    })
  };

  // A really lightweight plugin wrapper around the constructor,
  // preventing against multiple instantiations
  $.fn[pluginName] = function (options) {
    return this.each(function () {
      if (!$.data(this, 'plugin_' + pluginName)) {
        $.data(this, 'plugin_' + pluginName,
          new Plugin(this, options));
      }
    });
  }

})(jQuery, window, document);